import axios from 'axios';
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      products: [],
      filteredProducts: [],
      productsLoaded: false,
      debounced: null,

      error: {},
    };
  },

  watch: {
    query(searchString) {
      this.filterQuery(searchString);
    },
  },

  created() {
    this.fetchProducts();
  },

  methods: {
    fetchProducts() {
      this.error = {};

      axios.get('/admin/api/v1/product')
        .then((response) => {
          this.products = response.data.products;
          this.productsLoaded = true;
        })
        .catch(() => {
          this.products = [];
          this.productsLoaded = true;

          this.error.message = 'Kunne ikke hente produkter.';
        });
    },

    // Method that uses debounce function from lodash so that we don't send unnecessary requests
    filterQuery: _.debounce(function (searchString) {
      if (this.query === '') {
        this.filteredProducts = [];
      } else {
        this.filteredProducts = this.products.filter(product => (
            product.visma_article_id.toLowerCase().includes(searchString.toLowerCase()) ||
            product.name.toLowerCase().includes(searchString.toLowerCase())
          ));
      }
    }, 250),
  },
};
